const IMAGE = Object.freeze({
    OFFICIAL_LOGO: {
        name: 'official_logo',
        svg: true,
        common: true,
    },
    CHECK_CIRCLE_OUTLINE: {
        name: 'check_success',
        svg: true,
        common: true,
        width: 70,
        centered: true
    },
    WHAT_HAPPENED: {
        name: 'what_happened',
        svg: false,
        common: false,
        width: 115,
        centered: true
    },
    UPLOAD_DOCS: {
        name: 'upload_docs',
        svg: false,
        common: false,
        width: 115,
        centered: true
    },
    SELECT_PAYOUT_PREFERENCE: {
        name: 'select_payout_preference',
        svg: false,
        common: false,
        width: 115,
        centered: true
    },
    CLAIM_ANALYZED: {
        name: 'claim_analyzed',
        svg: false,
        common: false,
        width: 115,
        centered: true
    },
    ICON_CALENDAR: {
        name: 'icon_calendar',
        width: 100,
    },
    STOPWATCH: {
        name: 'stopwatch',
        width: 80,
    },
    SUCCESS_CONFETTI_90PX: {
        name: 'success_confetti',
        width: 90,
    },
    ISOLOGO: {
        name: 'isologo',
        svg: true,
        common: true,
        width: 120,
        centered: true,
        alt: "favicon"
    },
    APPLE_STORE_BUTTON: {
        name: 'apple_store_button',
        common: true,
        width: 142,
        height: 46,
        centered: true,
        alt: "Download on the App Store"
    },
    GOOGLE_PLAY_BUTTON: {
        name: 'google_play_button',
        common: true,
        width: 150,
        height: 46,
        centered: true,
        alt:"Get it on Google Play"
    },
    ICON_CLIPBOARD: {
        name: 'icon_clipboard',
        common: true,
        maxWidth: 100,
        centered: true,
    },
    VENMO_PM_130PX: {
        name: 'venmo',
        common: true,
        width: 130,
        alt:"Venmo payout method"
    },
    PAYPAL_PM_130PX: {
        name: 'paypal',
        common: true,
        width: 130,
        alt:"PayPal payout method"
    },
    VENMO_PM_88PX: {
        name: 'venmo',
        common: true,
        width: 88,
        alt:"Venmo payout method"
    },
    PAYPAL_PM_88PX: {
        name: 'paypal',
        common: true,
        width: 88,
        alt:"PayPal payout method"
    },
    STETHOSCOPE_CLIPBOARD: {
        name: 'stethoscope_clipboard'
    },
    HOSPITAL_EXIT: {
        name: 'hospital_exit'
    },
    ENVELOPE_EOB: {
        name: 'envelope_eob'
    },
});

export default IMAGE;
